import { createContext, useContext,useState } from 'react';

const CurrentPageContext = createContext();

export function CurrentPageProvider({ children }) {
  const [current,setCurrent] = useState("emailCheck")

  return (
    <CurrentPageContext.Provider value={[current,setCurrent]}>
      {children}
    </CurrentPageContext.Provider>
  );
}

export function useCurrentContext() {
  return useContext(CurrentPageContext);
}